/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/StartedAt
 * @desc Showing experiment.started_at + allow for update
 */

import { FormShowEditDateContainer as FormShowEditDate } from 'labstep-web/core/Form/ShowEdit/Date';
import type React from 'react';
import type { ExperimentFormShowEditStartedAtProps } from './types';

export const ExperimentFormShowEditStartedAt: React.FC<
  ExperimentFormShowEditStartedAtProps
> = ({ experiment }) => {
  return (
    <FormShowEditDate
      dataCy="components/Experiment/Form/ShowEdit/StartedAt"
      entity={experiment}
      field="started_at"
      label="start"
      dateTimePickerOptions={{ maxDate: experiment.ended_at }}
    />
  );
};
